import { css } from '@emotion/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { DropdownItemComponent } from '~/_shared/baseComponents/dropdown';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { InputSize } from '~/_shared/baseComponents/inputs';
import { NumberInCircleComponent } from '~/_shared/baseComponents/numberInShape/numberInCircle.component';
import { type ActiveBoundaryFillInfoEntities } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useGetBoundaryFillEntities';

const fillDropDownOptionStyles = css({
  minWidth: '100%',
  paddingInline: 10,
  height: 32,
});

const optionWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

const numberInCircleStyles = css({
  fontSize: 14,
});

type ActiveBoundaryDropdownOptionProps = Readonly<{
  entities: ActiveBoundaryFillInfoEntities;
  fillOrderNumber: number | null;
  backgroundColor: string;
  foregroundColor: string;
  onClick: () => void;
}>;

export const ActiveBoundaryDropdownOptionComponent = ({
  entities,
  fillOrderNumber,
  backgroundColor,
  foregroundColor,
  onClick,
}: ActiveBoundaryDropdownOptionProps) => {
  const { shortenedMainEntity, shortenedSubEntity } = entities;

  if (fillOrderNumber === null) {
    return null;
  }

  return (
    <DropdownItemComponent
      css={fillDropDownOptionStyles}
      name=""
      onClick={onClick}
      prefix={(
        <div css={optionWrapperStyles}>
          <NumberInCircleComponent
            css={numberInCircleStyles}
            colors={{
              fillColor: backgroundColor,
              fontColor: foregroundColor,
            }}
            size={18}
          >
            {fillOrderNumber}
          </NumberInCircleComponent>
          <div>
            {shortenedMainEntity}
          </div>
          {shortenedSubEntity && (
            <FontAwesomeIcon
              icon={faChevronRight}
              size="xs"
            />
          )}
          {shortenedSubEntity && (
            <div>
              {shortenedSubEntity}
            </div>
          )}
        </div>
      )}
      size={InputSize.Small}
    />
  );
};
